import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { SearchOverlay } from '../SearchOverlay/SearchOverlay';

import { debounce } from 'lodash';

@Component
export class PredictiveSearch extends ThemeComponent {
    @Ref() searchInput!: HTMLInputElement;
    @Ref() searchResults!: HTMLDivElement;
    @Ref() toggle!: HTMLButtonElement;
    @Ref() toggleClose!: HTMLButtonElement;
    @Ref() container!: HTMLDivElement;
    @Prop() useOverlay!: boolean;
    private searchOverlay: SearchOverlay|null = null;

    scrollListener: (() => void)|null = null;

    init() {
        this.searchInput.addEventListener('input',
            debounce(() => {
                this.onChange();
            }, 300)
        );

        this.$listen(this.toggle, 'click',  () => {
            this.toggleSearch();
        });

        this.$listen(this.toggleClose, 'click',  () => {
            this.toggleSearch();
            this.toggle.classList.remove('visually-hidden');
            this.toggle.classList.remove('hidden-above-small-desktop');
        });

        this.searchOverlay = document.querySelector('.search-overlay');

        if (this.searchOverlay) {
            this.$subscribe(this.searchOverlay.onCloseChange, () => {
                this.toggleSearch();
            });
        }
    }

    toggleSearch() {
        document.dispatchEvent(new Event('toggle'));
        document.body.classList.toggle('no-scroll');
        document.querySelector('.site-header')?.classList.toggle('search-active');
        this.container.classList.toggle('is-active');
        this.toggle.classList.toggle('hidden-above-small-desktop');
        if (this.useOverlay) {
            this.searchOverlay?.toggleOverlay();
        }
    }

    onChange() {
        const searchTerm: string = this.searchInput.value.trim();

        if (!searchTerm.length) {
            this.clearResults();
            this.closeResults();
            return;
        }

        this.getResults(searchTerm);
    }

    appendResults(text: string): void {
        const format: Document = new DOMParser().parseFromString(text, 'text/html');
        const resultsMarkup: string | undefined =
            format.querySelector('#shopify-section-predictive-search')?.innerHTML || undefined;

        if (resultsMarkup === undefined) {
            return;
        }

        this.searchResults.innerHTML = resultsMarkup;
    }

    clearResults(): void {
        const results: HTMLDivElement | null = document.querySelector('#predictive-search-results') || null;

        if (results) {
            results.remove();
        }
    }

    openResults(): void {
        this.searchResults.classList.add('is-active');
    }

    closeResults(): void {
        this.searchResults.classList.remove('is-active');
    }

    scrollOccured() {
        this.searchInput.value = "";
        this.clearResults();
        this.closeResults();
    }

    getResults(searchTerm: string): void {
        const url: string =
            // eslint-disable-next-line max-len
            `/search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection&resources[options][unavailable_products]=hide&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=body,title,tag,author&section_id=predictive-search`;

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`${response.status}`);
                }
                return response.text();
            })
            .then((text) => {
                this.appendResults(text);
                this.openResults();
            })
            .catch((error) => {
                throw error;
            });
    }

    toggleScrollEvent() {
        if (!this.scrollListener) {
            this.scrollListener = () => this.scrollOccured();
            window.addEventListener('scroll', this.scrollListener);
        } else {
            window.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = null;
        }
    }
}
